import moment from 'moment'
import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import { Link } from 'react-router-dom'

import { manageVcIconClassName, manageStatusStyle } from '@modules/admin/monitoring/actions'
import { ProfessionalStatus } from '@modules/admin/monitoring/template'

export class MonitoringTable extends Component {
  state = {
    showTable: true,
  }

  render() {
    const { professionals, type, handleOpenModal } = this.props
    const getVisibility = this.state.showTable ? 'visible' : 'hidden'

    return (
      <div>
        <div className="accordionTitle" onClick={() => this.setState({ showTable: !this.state.showTable })}>
          {type}
          <span className="fas fa-caret-right" />
        </div>
        <table className="md-table" style={{ visibility: getVisibility }}>
          <thead>
            <tr>
              <th title={i18next.t('Nombre')} className="col-big">
                <Trans>Nombre</Trans>
              </th>
              <th title={i18next.t('Estado')}>
                <Trans>Estado</Trans>
              </th>
              {type === 'online' ? (
                <>
                  <th title={i18next.t('Cerrar sesión')}>
                    <Trans>Cerrar sesión</Trans>
                  </th>
                  <th title={i18next.t('Desconexión')} className="col-large">
                    <Trans>Desconexión</Trans>
                  </th>
                  <th title={i18next.t('Total')}>
                    <Trans>Total</Trans>
                  </th>
                  <th title={i18next.t('P.Último mes')}>
                    <Trans>P.Último mes</Trans>
                  </th>
                  <th title={i18next.t('Pendiente')}>
                    <Trans>Pendiente</Trans>
                  </th>
                  <th title={i18next.t('Tiempo [min]')}>
                    <Trans>Tiempo [min]</Trans>
                  </th>
                </>
              ) : (
                <>
                  <th title={i18next.t('Conexión')}>
                    {' '}
                    <Trans>Conexión</Trans>{' '}
                  </th>
                  <th title={i18next.t('P.Último mes')}>
                    <Trans>P.Último mes</Trans>
                  </th>
                  <th title={i18next.t('Pendiente')}>
                    {' '}
                    <Trans>Pendiente</Trans>{' '}
                  </th>
                </>
              )}
              <th title={i18next.t('videocall')}>Vc</th>
            </tr>
          </thead>
          <tbody>
            {professionals.map((professional) => (
              <tr key={professional.id}>
                <td className="name">
                  <div
                    className="severidad"
                    style={{
                      backgroundColor: professional.answerTimeColor || professional.pendingRoomsColor,
                    }}
                  />
                  <Link to={`professional/${professional.id}`}>{professional.name}</Link>
                  <div className="speciality">{professional.speciality && professional.speciality.name}</div>
                </td>
                <td>
                  <ProfessionalStatus {...manageStatusStyle(professional.professional_status)} />
                </td>
                {type === 'online' ? (
                  <>
                    <td onClick={() => handleOpenModal(professional)} className="signout">
                      <span
                        className="fas fa-sign-out-alt"
                        // onClick={ () => this.disconnectProfessional(professional) }
                      />
                    </td>
                    <td>
                      {professional.nicely_connected ? (
                        moment(professional.next_disconnection_at).format('ddd HH:mm')
                      ) : (
                        <span className="outOfSchedule">
                          {' '}
                          <Trans>Excedido</Trans>{' '}
                        </span>
                      )}
                    </td>
                    <td>{professional.total_rooms}</td>
                    <td>{professional.last_month}</td>
                    <td>{professional.pending_rooms}</td>
                    <td>
                      {professional.oldest_room_id ? (
                        <Link
                          to={`room/${professional.oldest_room_id}`}
                          style={{ color: professional.answerTimeColor }}
                        >
                          {professional.answerTime}
                        </Link>
                      ) : (
                        professional.answerTime
                      )}
                    </td>
                  </>
                ) : (
                  <>
                    <td>
                      {!!professional.nicely_connected ? (
                        moment(professional.next_connection_at).format('ddd HH:mm')
                      ) : (
                        <span className="outOfSchedule">
                          {' '}
                          <Trans>Ausente</Trans>{' '}
                        </span>
                      )}
                    </td>
                    <td>{professional.last_month}</td>
                    <td>{professional.pending_rooms}</td>
                  </>
                )}
                {professional.professional_status.video_label && (
                  <td>
                    <i
                      className={manageVcIconClassName({
                        vcStatus: professional.professional_status.video_label,
                      })}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}
